/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramFeedControllerGetFeedQueryResponse,
  TelegramFeedControllerGetFeedQueryParams,
  TelegramFeedControllerGetFeed401,
} from '../../types/TelegramFeedControllerGetFeed.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { telegramFeedGetFeed } from '../../methods/telegramFeedGetFeed.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const telegramFeedGetFeedQueryKey = (params?: TelegramFeedControllerGetFeedQueryParams) =>
  [{ url: '/api/telegram/feed' }, ...(params ? [params] : [])] as const;

export type TelegramFeedGetFeedQueryKey = ReturnType<typeof telegramFeedGetFeedQueryKey>;

export function telegramFeedGetFeedQueryOptions(
  params?: TelegramFeedControllerGetFeedQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = telegramFeedGetFeedQueryKey(params);
  return queryOptions<
    TelegramFeedControllerGetFeedQueryResponse,
    ResponseErrorConfig<TelegramFeedControllerGetFeed401>,
    TelegramFeedControllerGetFeedQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return telegramFeedGetFeed(params, config);
    },
  });
}

/**
 * {@link /api/telegram/feed}
 */
export function useTelegramFeedGetFeed<
  TData = TelegramFeedControllerGetFeedQueryResponse,
  TQueryData = TelegramFeedControllerGetFeedQueryResponse,
  TQueryKey extends QueryKey = TelegramFeedGetFeedQueryKey,
>(
  params?: TelegramFeedControllerGetFeedQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        TelegramFeedControllerGetFeedQueryResponse,
        ResponseErrorConfig<TelegramFeedControllerGetFeed401>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? telegramFeedGetFeedQueryKey(params);

  const query = useQuery(
    {
      ...telegramFeedGetFeedQueryOptions(params, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<TelegramFeedControllerGetFeed401>> & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
